<!-- aca empieza el formulario -->

<div class="animated fadeIn" id="todo">
    <div class="col-lg-12">

        <app-loading class="m-5" *ngIf="loading"></app-loading>

        <h5>
            ORDENES DE PAGO
        </h5>
        
        
        <hr>

        <div id="grid" #TABLE>
            <mat-form-field>
                <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtrar..">
            </mat-form-field>

            <div class="example-container mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
                    <!-- Checkbox Column -->
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
                            </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <!-- Position Column -->
                    <ng-container matColumnDef="position">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> No. </th>
                        <td mat-cell *matCellDef="let element"> {{element.position}} </td>
                    </ng-container>

                    <ng-container matColumnDef="IDPAGO">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> OP NRO </th>
                        <td mat-cell *matCellDef="let element"> {{element.IDPAGO}} </td>
                    </ng-container>

                    <ng-container matColumnDef="FORMAPAGO">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> FORMA PAGO </th>
                        <td mat-cell *matCellDef="let element"> {{element.FORMAPAGO}} </td>
                    </ng-container>
                    <ng-container matColumnDef="FECHAPAGO">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA PAGO </th>
                        <td mat-cell *matCellDef="let element"> {{element.FECHAPAGO | date:"dd/MM/yy"}} </td>
                    </ng-container>
                    <ng-container matColumnDef="DETALLE">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> DETALLE </th>
                        <td style="font-style: italic; font-weight: bold;" mat-cell *matCellDef="let element">"{{(element.DETALLE !=='null') ? (element.DETALLE) : ('----')}}"</td>
                        <!-- <td style="font-style: italic; font-weight: bold;" mat-cell *matCellDef="let element">"{{ (element.DETALLE===null) ? ('null') : "---" }}"</td> -->
                    </ng-container>
                    <ng-container matColumnDef="SUMA">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> SUBTOT </th>
                        <td style="font-weight: bold;" mat-cell *matCellDef="let element"> {{element.SUMA | currency:"$" }} </td>
                    </ng-container>
                    <ng-container matColumnDef="FONDO">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> FONDO </th>
                        <td style="font-weight: bold;" mat-cell *matCellDef="let element"> (-){{element.FONDO | currency:"$" }} </td>
                    </ng-container>
                    <ng-container matColumnDef="TOTAL">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> TOTAL </th>
                        <td style="font-weight: bold;" mat-cell *matCellDef="let element"> {{element.TOTAL | currency:"$" }} </td>
                    </ng-container>
                    <ng-container matColumnDef="NROOPERA">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> NROOPERA </th>
                        <td mat-cell *matCellDef="let element"> {{ element.NROOPERA }} </td>
                    </ng-container>
                    <ng-container matColumnDef="CODBANCO">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> CODBANCO </th>
                        <td mat-cell *matCellDef="let element"> {{ element.CODBANCO }} </td>
                    </ng-container>
                    <ng-container matColumnDef="TIPOPAGO">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> TIPOPAGO </th>
                        <td mat-cell *matCellDef="let element"> {{ element.TIPOPAGO }} </td>
                    </ng-container>
                    <ng-container matColumnDef="SECCIONAL">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> SEC/DEL </th>
                        <td mat-cell *matCellDef="let element"> {{ element.SECCIONAL }} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row (click)="selectRow(row.IDPAGO)" data-toggle="modal" data-target="#MODALDATOS" *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row);"></tr>
                </table>
            </div>
            <mat-paginator [pageSize]=50 [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
            <hr>
            <button class="btn-block" color="dark" mat-button>Exportar a Excel</button>
        </div>
        <hr>

        <button type="button" class="btn btn-secondary btn-block" mat-button routerLink="/home">Volver</button>
    </div>

</div>



<!-- MODAL GET IMAGEN-->
<div class="modal fade" id="MODALDATOS" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div style="margin-top: 90px;" class="modal-dialog modal-lg" role="document">
        <div id="modalito" class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Orden de Pago Nro: {{ codi_pago_edit }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body">
                <div style="text-align: center;">
                    <app-loading class="m-5" *ngIf="loading2"></app-loading>
                    <div *ngIf="!loading2">
                        <h5 class="modal-title" id="exampleModalLabel">DETALLE: "{{ det }}"</h5>
                        <h5 class="modal-title" id="exampleModalLabel">CUENTA: {{ cuenta }}</h5>
                        <h5 class="modal-title" id="exampleModalLabel">NRO-OPERAC: {{ nroope }}</h5>
                        <br>
                    </div>
                    <p>ver codigos de gasto que afecta:</p>
                    <select *ngIf="!loading2" class="form-control">
                        <option *ngFor="let gas of dataSourcePago">CODGAS: {{ gas.CODGASTO }} / IMP: {{ gas.IMPORTE | currency:"$"}} / DETALLE: {{gas.DETPADRE}}</option>
                    </select>
                    <hr>
                    <p>IMPORTANTE: Si es un gasto EXTERNO, se mostraran los DETALLES de gastos, caso SISTEMA, se mostraran los CODGASTOS involucrados</p>
                    <hr>
                    <a target="_blank" routerLink="/impresionorden" style="cursor: pointer" *ngIf="!loading2" data-dismiss="modal" (click)="reimprimir()" type="button" class="btn btn-primary">RE-IMPRIMIR Orden de Pago ({{codi_pago_edit}})</a>
                    <a  id="botonImprime" class="whites" style="cursor: pointer" type="button" target="_blank" routerLink="/impresionorden" hidden>CANCEL</a>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Volver</button>
            </div>
        </div>
    </div>
</div>
